var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrancSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 56C320 69.25 309.25 80 296 80H96V192H264C277.25 192 288 202.75 288 216S277.25 240 264 240H96V320H200C213.25 320 224 330.75 224 344S213.25 368 200 368H96V456C96 469.25 85.25 480 72 480S48 469.25 48 456V368H24C10.75 368 0 357.25 0 344S10.75 320 24 320H48V56C48 42.75 58.75 32 72 32H296C309.25 32 320 42.75 320 56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrancSign);
export default __webpack_public_path__ + "static/media/franc-sign.19e4172bf6f743af100baa5b18633bf5.svg";
export { ForwardRef as ReactComponent };